export const productionConfig = {
  strapi: {
    url: "https://feedbackdoctor-production-strapi.kumpel.cloud",
    graphqlUrl: "https://feedbackdoctor-production-strapi.kumpel.cloud/graphql",
  },
  misc: {
    consentCookieDomain: "feedbackdoktor.de",
  },
  cloudinary: {
    cloud_name: process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME,
    api_key: "155829952288219",
    api_secret: process.env.CLOUDINARY_SECRET,
  },
  googleRecaptchaSiteKey: "6LfcYvwpAAAAAOyYRPmVJr2ZBmPWqcmUHHrzcGCV",
};
